import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgB2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "B2",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 100,
				height: 100,
				fill: "#34D399"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M50.2958 76.667C49.6292 76.667 49.0859 77.2084 49.0859 77.8782V79.6916C49.0859 79.7205 49.0858 79.7494 49.0855 79.7783V87.705C49.0855 89.0413 48.0022 90.1247 46.6659 90.1247H25.4938C21.4848 90.1247 18.2349 86.8747 18.2349 82.8657C18.2349 78.8567 21.4848 75.6067 25.4938 75.6067H31.0704C32.1948 65.9874 40.3721 58.5195 50.2958 58.5195C60.2206 58.5195 68.3958 65.9897 69.5209 75.6067H75.0985C79.1075 75.6067 82.3575 78.8567 82.3575 82.8657C82.3575 86.8747 79.1075 90.1247 75.0985 90.1247H53.9265C52.5901 90.1247 51.5068 89.0413 51.5068 87.705V79.8412C51.506 79.7914 51.5056 79.7415 51.5056 79.6916V77.88C51.5056 77.2082 50.9602 76.667 50.2958 76.667Z",
				fill: "url(#paint0_linear_7220_21632)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M47.2337 12.0395C48.8923 10.8892 51.0906 10.8892 52.7493 12.0395L66.9161 21.8643L80.9794 31.0077C82.8757 32.2406 83.665 34.6226 82.8802 36.744L77.3761 51.6222L72.2667 66.9545C71.6001 68.9547 69.7152 70.2932 67.607 70.2633L49.9915 70.0135L32.376 70.2633C30.2678 70.2932 28.3828 68.9547 27.7162 66.9545L22.6068 51.6222L17.1027 36.744C16.3179 34.6226 17.1073 32.2406 19.0035 31.0077L33.0668 21.8643L47.2337 12.0395Z",
				fill: "url(#paint1_radial_7220_21632)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.2422 43.6072C44.2422 42.2708 45.3255 41.1875 46.6618 41.1875C47.9982 41.1875 49.0815 42.2708 49.0815 43.6072V46.0268C49.0815 47.3632 47.9982 48.4465 46.6618 48.4465C45.3255 48.4465 44.2422 47.3632 44.2422 46.0268V43.6072Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51.5029 43.6072C51.5029 42.2708 52.5862 41.1875 53.9226 41.1875C55.2589 41.1875 56.3422 42.2708 56.3422 43.6072V46.0268C56.3422 47.3632 55.2589 48.4465 53.9226 48.4465C52.5862 48.4465 51.5029 47.3632 51.5029 46.0268V43.6072Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.2422 51.4707L48.4173 54.8108C49.5129 55.6873 51.0698 55.6873 52.1654 54.8108L56.3405 51.4707",
				stroke: "#10B981",
				strokeWidth: 3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_7220_21632",
				x1: 50.2962,
				y1: 58.5195,
				x2: 50.2962,
				y2: 90.1247,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#2DD4BF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#BBF7D0"
				})]
			}), /* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_7220_21632",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(49.9915 43.3973) rotate(90) scale(33.2703 35.9924)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CCFBF1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DCFCE7"
				})]
			})] })
		]
	})
});
export default SvgB2;
